import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface RuntimeIssue {
  source: string;
  message: string;
  occurredOn: string;
  count: number;
}

@Injectable({ providedIn: 'root' })
export class RuntimeHealthService {
  private readonly runtimeIssueSubject = new BehaviorSubject<RuntimeIssue | null>(null);

  readonly runtimeIssue$ = this.runtimeIssueSubject.asObservable();

  reportIssue(source: string, message: string): void {
    const nextMessage = message.trim() || 'Unexpected runtime failure.';
    const nextSource = source.trim() || 'runtime';
    const currentIssue = this.runtimeIssueSubject.value;

    if (currentIssue && currentIssue.source === nextSource && currentIssue.message === nextMessage) {
      this.runtimeIssueSubject.next({
        ...currentIssue,
        count: currentIssue.count + 1,
        occurredOn: new Date().toISOString(),
      });
      return;
    }

    this.runtimeIssueSubject.next({
      source: nextSource,
      message: nextMessage,
      occurredOn: new Date().toISOString(),
      count: 1,
    });
  }

  clearIssue(): void {
    this.runtimeIssueSubject.next(null);
  }
}
